import type { BadgeVariant } from '@/components/ui';
import type { HrDocumentStatus } from '@/api/services/hrDocuments.service';

export const LETTER_STATUS: Record<HrDocumentStatus, { label: string; variant: BadgeVariant }> = {
  generated: { label: 'Draft', variant: 'neutral' },
  issued: { label: 'Awaiting signature', variant: 'info' },
  partially_signed: { label: 'Partly signed', variant: 'info' },
  completed: { label: 'Signed', variant: 'success' },
  refused: { label: 'Declined', variant: 'danger' },
  expired: { label: 'Expired', variant: 'warning' },
  voided: { label: 'Withdrawn', variant: 'neutral' },
};

export function formatLetterDate(value: string | undefined | null): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? '—'
    : date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatLetterInstant(value: string | undefined | null): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? '—'
    : date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}
